module.exports = __webpack_public_path__ + "static/CVS-Be-Vape-Free-Loop-FINAL-07a482e31b113dff738e8d28d7e0042c.mp4";